var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductGrp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    transform: "translate(24) scale(-1 1)",
    fill: "white",
    stroke: "#EF8127"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41394 3.816C7.13127 3.816 8.37927 4.152 9.15794 4.824C9.94727 5.48533 10.3419 6.50933 10.3419 7.896C10.3419 9.272 9.9366 10.28 9.12594 10.92C8.32594 11.56 7.09927 11.88 5.44594 11.88H3.95794V15H1.46194V3.816H5.41394ZM5.63794 9.72C6.46994 9.72 7.03527 9.55467 7.33394 9.224C7.6326 8.88267 7.78194 8.392 7.78194 7.752C7.78194 7.10133 7.5846 6.64267 7.18994 6.376C6.80594 6.09867 6.20327 5.96 5.38194 5.96H3.95794V9.72H5.63794Z",
    transform: "translate(7 3)",
    fill: "#EF8127"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductGrp);
export default __webpack_public_path__ + "static/media/productGrp.695ec86b0bf2f487ad55cf4cc0f65763.svg";
export { ForwardRef as ReactComponent };